/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_DeletedInputs */

const en_carrier_notices_deleted = /** @type {(inputs: Carrier_Notices_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier notice deleted.`)
};

const es_carrier_notices_deleted = /** @type {(inputs: Carrier_Notices_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de transportista eliminado.`)
};

/**
* | output |
* | --- |
* | "Carrier notice deleted." |
*
* @param {Carrier_Notices_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_deleted = /** @type {((inputs?: Carrier_Notices_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_deleted(inputs)
	return es_carrier_notices_deleted(inputs)
});